import React, { Component }  from 'react';
import { TemplateConstants } from './environment';
import { isInRoleFromToken } from '../../../utils/authService';

class TemplateBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(TemplateConstants.AdminRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={TemplateConstants.AdminHashPrefix} className="anchor c-breadcrumbs__anchor" >
                Admin Landing
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (TemplateConstants.UserRole === "*" || isInRoleFromToken(TemplateConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={TemplateConstants.UserHashPrefix} className="anchor c-breadcrumbs__anchor" >
                User Landing
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default TemplateBreadcrumb;